const PasswordRequirements = () => {
  return (
    <div className="mt-2 space-y-1">
      <p className="text-sm text-gray-500">
        Requirements: 8 characters, 1 uppercase, 1 lowercase, 1 number, 1
        special character
      </p>
    </div>
  );
};

export default PasswordRequirements;
